module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1800.847bd70e.svg";